import React from 'react';
import { Controller } from 'react-hook-form';
import PropTypes from 'prop-types';
import { Input } from 'antd';
import { AdminInputWrapper, AdminInputLabel, AdminInputError } from './common';

/*
  Default exports an text input wrapped in react-hook-form's Controller HOC.
  A stand-alone text input is also available for export.
*/

const AdminTextInput = (props) => {
  const {
    placeholder,
    disabled,
    error,
    label,
    control,
    name,
    rules,
    className,
    onChange,
    size,
    defaultValue,
  } = props;
  const isRequired = rules && !!rules.required;
  return (
    <AdminInputWrapper type="text">
      { label && <AdminInputLabel required={isRequired}>{ label }</AdminInputLabel> }
      <Controller
        control={control}
        name={name}
        rules={rules}
        defaultValue={defaultValue}
        render={({ onChange: controllerOnChange, value }) => (
          <Input
            size={size}
            placeholder={placeholder}
            className={className}
            value={value}
            onChange={(text) => {
              controllerOnChange(text);
              if (onChange) {
                onChange(text);
              }
            }}
            disabled={disabled}
          />
        )}
      />
      { error && <AdminInputError>{ error.message }</AdminInputError> }
    </AdminInputWrapper>
  );
};

AdminTextInput.propTypes = {
  placeholder: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.shape({
    message: PropTypes.string,
  }),
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  rules: PropTypes.shape({
    required: PropTypes.string,
  }),
  onChange: PropTypes.func,
  control: PropTypes.shape({}).isRequired, // Provided by react-hook-form, passed in via parent
  size: PropTypes.string,
  defaultValue: PropTypes.string,
};

AdminTextInput.defaultProps = {
  disabled: false,
  placeholder: null,
  className: null,
  error: null,
  label: null,
  rules: null,
  onChange: null,
  size: 'large',
  defaultValue: null,
};

export default AdminTextInput;

export const StandaloneAdminTextInput = (props) => {
  const {
    placeholder,
    value,
    onChange,
    disabled,
    className,
    error,
    label,
  } = props;
  return (
    <AdminInputWrapper type="text">
      { label && <AdminInputLabel>{ label }</AdminInputLabel> }
      <Input
        size="large"
        className={`ant-input ${className}`}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
      { error && <AdminInputError>{ error }</AdminInputError> }
    </AdminInputWrapper>
  );
};

StandaloneAdminTextInput.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  label: PropTypes.string,
};

StandaloneAdminTextInput.defaultProps = {
  onChange: null,
  disabled: false,
  placeholder: null,
  value: '',
  className: null,
  error: null,
  label: null,
};
